var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortMini(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104558",
    "data-name": "Group 104558",
    transform: "translate(-477 -520)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104445",
    "data-name": "Group 104445",
    transform: "translate(22413 14665)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9388",
    "data-name": "Ellipse 9388",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21936 -14145)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9390",
    "data-name": "Ellipse 9390",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21936 -14139)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9392",
    "data-name": "Ellipse 9392",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21936 -14133)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9389",
    "data-name": "Ellipse 9389",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21930 -14145)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9391",
    "data-name": "Ellipse 9391",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21930 -14139)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9393",
    "data-name": "Ellipse 9393",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21930 -14133)",
    fill: "silver"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortMini);
export default __webpack_public_path__ + "static/media/SortMini.b374d6f72383ac794137e6e5d8fc07db.svg";
export { ForwardRef as ReactComponent };